// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loading_Container__2ySrm","Logo":"Loading_Logo__2VTPB","Loading":"Loading_Loading__2QGVy","spin":"Loading_spin__27TzB"};